import { ServiceId } from "@mirage/discovery/id";
import * as services from "@mirage/discovery/services";

import type { Service } from "@mirage/service-fss-native/service";

const service = services.getp<Service>(ServiceId.FSS_NATIVE);
const service$ = services.get<Service>(ServiceId.FSS_NATIVE);

export function getCurrentAccount() {
  return service.getCurrentAccount();
}

export function reloadView() {
  return service.reloadView();
}

export function showDashWindow() {
  return service.showDashWindow();
}

export function hideDashWindow() {
  return service.hideDashWindow();
}

export function getAccessToken() {
  return service.getAccessToken();
}

export function getShortcutValue() {
  return service.getShortcutValue();
}

export function getFeatureSessionId() {
  return service.getFeatureSessionId();
}

export function addDashEsvEventListener(
  ...args: Parameters<Service["addDashEsvEventListener"]>
) {
  return service.addDashEsvEventListener(...args);
}

export function sendMessageToRenderer(
  ...args: Parameters<Service["sendMessageToRenderer"]>
) {
  return service.sendMessageToRenderer(...args);
}

export function launchPersistentWindow() {
  return service.launchPersistentWindow();
}

export function getViewName() {
  return service.getViewName();
}

export { service$ };

export type { Service } from "@mirage/service-fss-native/service";
